import React from "react";
import { Check } from "lucide-react";

export default function WizardStepper({ steps, current, onJump }) {
  return (
    <div
      className="rounded-2xl border border-border/80 bg-card/80 p-2.5 shadow-sm sm:p-3"
      data-testid="wizard-stepper"
    >
      <div className="flex items-center w-full gap-1">
        {steps.map((s, i) => {
          const isActive = i === current;
          const isDone = i < current;
          const canJump = Boolean(onJump && i <= current);

          return (
            <React.Fragment key={s.label}>
              <button
                type="button"
                onClick={() => canJump && onJump(i)}
                disabled={!canJump && !isActive}
                data-testid={`wizard-step-${i}`}
                className={`group flex min-w-0 items-center gap-2 rounded-xl px-2 py-2.5 text-left transition-all sm:px-3 ${
                  isActive
                    ? "bg-primary/10 text-foreground ring-1 ring-primary/20"
                    : isDone
                      ? "text-primary hover:bg-primary/5"
                      : "cursor-default text-muted-foreground"
                }`}
                aria-current={isActive ? "step" : undefined}
              >
                <span
                  className={`grid size-8 shrink-0 place-items-center rounded-full border font-mono text-xs font-semibold transition-all ${
                    isActive
                      ? "border-primary bg-primary text-primary-foreground shadow-sm"
                      : isDone
                        ? "border-primary/30 bg-primary/10 text-primary"
                        : "border-border bg-background text-muted-foreground"
                  }`}
                >
                  {isDone ? <Check className="size-3.5" /> : i + 1}
                </span>

                <span className="hidden min-w-0 md:block">
                  <span className="block text-[10px] font-mono uppercase tracking-[0.12em] text-muted-foreground">
                    Etapa {i + 1}
                  </span>
                  <span className={`block truncate text-sm font-semibold ${isActive ? "text-foreground" : ""}`}>
                    {s.label}
                  </span>
                </span>
              </button>

              {i < steps.length - 1 && (
                <div className="relative h-px flex-1 overflow-hidden rounded-full bg-border">
                  <div
                    className={`absolute inset-y-0 left-0 bg-primary transition-all duration-300 ${i < current ? "w-full" : "w-0"}`}
                  />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      <div className="mt-2 flex items-center justify-between gap-3 border-t border-border/60 px-2 pt-2 md:hidden">
        <div>
          <div className="text-[10px] font-mono uppercase tracking-[0.12em] text-muted-foreground">Etapa {current + 1} de {steps.length}</div>
          <div className="text-sm font-semibold">{steps[current]?.label}</div>
        </div>
        <div className="font-mono text-xs text-muted-foreground">
          {Math.round(((current + 1) / steps.length) * 100)}%
        </div>
      </div>
    </div>
  );
}
